import { initContract } from "@ts-rest/core";
import { authenticationBackofficeContract } from "~infrastructure/api/backoffice/contract/authentication/authentication-backoffice-contract.ts";
import { devicesBackofficeContract } from "~infrastructure/api/backoffice/contract/devices/devices-backoffice-contract.ts";
import { backofficeErrorSchema } from "~infrastructure/api/backoffice/contract/global/responses/global-backoffice-responses.ts";
import { installTestsBackofficeContract } from "~infrastructure/api/backoffice/contract/install-tests/install-tests-backoffice-contract.ts";
import { othersBackofficeContract } from "~infrastructure/api/backoffice/contract/others/others-backoffice-contract.ts";
import { sitesBackofficeContract } from "~infrastructure/api/backoffice/contract/site/sites-backoffice-contract.ts";

const c = initContract();

export const backofficeContract = c.router(
  {
    authentication: authenticationBackofficeContract,
    others: othersBackofficeContract,
    devices: devicesBackofficeContract,
    installTests: installTestsBackofficeContract,
    sites: sitesBackofficeContract,
  },
  {
    strictStatusCodes: true,
    commonResponses: {
      403: backofficeErrorSchema,
      500: backofficeErrorSchema,
      502: backofficeErrorSchema,
    },
  },
);
